module.exports = __webpack_public_path__ + "static/media/student-loggedinn.8478cbe8.jpg";